import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { OrderHistoryProductModel } from "@store/Types/ApiModels";
import cloneDeep from "lodash/cloneDeep";

type Parameter = {
    selectedProduct: OrderHistoryProductModel;
};

interface Props extends StoreHandlerProps {
    selectedProduct: OrderHistoryProductModel;
}

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginAddProduct: HandlerType = props => {
    const dispatch: any = props.dispatch;
    dispatch({
        type: "Pages/Rma/BeginAddProduct",
    });
};

export const CopyCurrentValues: HandlerType = props => {
    props.parameter.selectedProduct.qtyOrdered = props.parameter.selectedProduct.autocompleteItemModel.rmaNeedsSn
        ? 1
        : props.parameter.selectedProduct.qtyOrdered;
    props.selectedProduct = cloneDeep(props.parameter.selectedProduct);
};

export const DispatchSetRmaLine: HandlerType = props => {
    const dispatch = props.dispatch;
    dispatch({
        type: "Data/RmaRequest/SetRmaLine",
        LineId: props.parameter.selectedProduct.lineId,
        ProductErpNumber: props.parameter.selectedProduct.autocompleteItemModel.erpNumber,
        ProductDescription: props.parameter.selectedProduct.autocompleteItemModel.name,
        ReturnReason: "",
        ReturnedQuantity: props.parameter.selectedProduct.qtyOrdered,
    });
};

export const DispatchCompleteAddProduct: HandlerType = props => {
    const dispatch = props.dispatch;
    dispatch({
        type: "Pages/Rma/CompleteAddProduct",
        selectedProduct: props.selectedProduct,
    });
};

export const chain = [DispatchBeginAddProduct, CopyCurrentValues, DispatchSetRmaLine, DispatchCompleteAddProduct];

const addProduct = createHandlerChainRunner(chain, "AddProduct");
export default addProduct;
